export default {
  GEOLOCATION_STATE_MANAGER: Symbol.for('GEOLOCATION_STATE_MANAGER'),
  ON_CURRENT_POSITION_SUBSCRIPTION: Symbol.for('ON_CURRENT_POSITION_SUBSCRIPTION'),
  GEOLOCATION_REFERENCES_REPOSITORY: Symbol.for('GEOLOCATION_REFERENCES_REPOSITORY'),
  SEARCH_GEOLOCATION_REFERENCES_QUERY: Symbol.for('SEARCH_GEOLOCATION_REFERENCES_QUERY'),
  GEOLOCATION_SERVICE: Symbol.for('GEOLOCATION_SERVICE'),
};
